import React from "react";

const PADDING = {
  none: "",
  sm: "portal-card--pad-sm",
  md: "portal-card--pad",
  lg: "portal-card--pad-lg",
};

export function PortalCard({ children, className = "", padding = "md", as: Tag = "div", ...props }) {
  return (
    <Tag
      className={["portal-card", PADDING[padding] || PADDING.md, className].filter(Boolean).join(" ")}
      {...props}
    >
      {children}
    </Tag>
  );
}
